import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "w",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleClick && _ctx.onToggleClick(...args)))
  }, [
    _createVNode(_component_el_icon, { size: "1rem" }, {
      default: _withCtx(() => [
        (!_ctx.isExpand)
          ? (_openBlock(), _createBlock(_component_Plus, { key: 0 }))
          : (_openBlock(), _createBlock(_component_Minus, { key: 1 }))
      ]),
      _: 1
    })
  ]))
}